module.exports = __webpack_public_path__ + "img/search.86b405b0.svg";